<div class="container-fluid mt-4" *ngIf="items?.length > 0">
  <h5>{{ notification.libelle }}</h5>

  <!-- Badge modification en attente -->
  <div *ngIf="pendingChanges" class="alert alert-warning py-1 mb-2" style="font-size:.85rem;">
    <i class="fa fa-clock"></i>&nbsp;
    <strong>Modification en attente de validation</strong> — les champs surlignés indiquent les valeurs proposées.
  </div>

  <div class="table-responsive" style="max-height: 400px; overflow: auto">
    <table class="table table-striped table-bordered">
      <thead *ngIf="pendingChanges">
        <tr>
          <th>Champ</th>
          <th>Valeur actuelle</th>
          <th>Valeur proposée</th>
        </tr>
      </thead>
      <tbody>

        <!-- IMAGE ROW -->
        <ng-container *ngIf="items[0].image_url">
          <tr>
            <th class="text-capitalize">Image</th>
            <td class="p-2 text-center" [attr.colspan]="pendingChanges ? 2 : 1">
              <img
                [src]="items[0].image_url"
                alt="Image"
                class="img-fluid clickable-img"
                (click)="openPreview(items[0].image_url)"
                (error)="onImageError($event)"
                style="max-height: 200px; object-fit: contain; cursor: zoom-in;"
              />
            </td>
          </tr>
        </ng-container>

        <!-- DOWNLOAD ROW -->
        <ng-container *ngIf="items[0].file_url">
          <tr>
            <th class="text-capitalize">Fichier</th>
            <td class="p-2" [attr.colspan]="pendingChanges ? 2 : 1">
              <a [href]="items[0].file_url" download target="_blank"
                rel="noopener noreferrer" class="btn btn-primary btn-sm">
                Download File
              </a>
            </td>
          </tr>
        </ng-container>

        <!-- OTHER FIELDS — mode diff -->
        <ng-container *ngFor="let key of getKeys(items[0])">
          <ng-container *ngIf="key !== 'image_url' && key !== 'file_url' && key !== 'pending_changes'">

            <!-- Avec diff -->
            <tr *ngIf="pendingChanges" [ngClass]="{'table-warning': isChanged(key)}">
              <th class="text-capitalize">{{ formatLabel(key) }}</th>
              <td>{{ items[0][key] ?? '—' }}</td>
              <td>
                <span *ngIf="isChanged(key)" class="fw-bold text-danger">
                  {{ getPendingValue(key) ?? '—' }}
                </span>
                <span *ngIf="!isChanged(key)" class="text-muted">—</span>
              </td>
            </tr>

            <!-- Sans diff (création) -->
            <tr *ngIf="!pendingChanges">
              <th class="text-capitalize">{{ formatLabel(key) }}</th>
              <td>{{ items[0][key] ?? '—' }}</td>
            </tr>

          </ng-container>
        </ng-container>

      </tbody>
    </table>
  </div>
</div>

<!-- FULLSCREEN IMAGE OVERLAY -->
<ng-container *ngIf="previewOpen">
  <div class="image-overlay" (click)="closePreview()">
    <img
      [src]="previewSrc"
      alt="Preview"
      class="preview-img"
      (click)="$event.stopPropagation()"
    />
    <span class="close-btn" (click)="closePreview()">&times;</span>
  </div>
</ng-container>
